'use strict';

import { AdType } from '../constants/AdType';
import { extendDefaults, getScript } from '../utils/common';
import EventBus from '../components/EventBus';
import URLParse from 'url-parse';
import AdFlowProcessSpinner from './AdFlowProcessSpinner';

class AdInstance {
  constructor(e, options, n) {
    var defaultOptions = {
      debug: !1,
      width: 640,
      height: 360,
      locale: 'en',
    };
    this.options = options ? extendDefaults(defaultOptions, options) : defaultOptions;
    this.prefix = 'g8plugin__';
    this.adsLoader = null;
    this.adsManager = null;
    this.adDisplayContainer = null;
    this.eventBus = new EventBus();
    this.safetyTimer = null;
    this.containerTransitionSpeed = 0;
    this.adCounter = {};
    this.adPrerollCount = 0;
    this.adMidrollCount = 0;
    this.adRewardedCount = 0;
    this.preloadedAdType = null;
    this.requestRunning = !1;
    this.parentDomain = n.parentDomain;
    this.topDomain = n.topDomain;
    this.parentURL = n.parentURL;
    this.adDisplayContainerInitialized = !1;
    this.IMASampleTags = {
      interstitial: [
        'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear&correlator=',
        'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dredirectlinear&correlator=',
        'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dredirecterror&correlator=',
      ],
      rewarded: [
        'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dlinear&correlator=',
      ],
    };
    this.atom_display;
    this.adType_ = '';
    this.clickCount = {
      midroll: 0,
      preroll: 0,
      rewarded: 0,
    };

    this.category = '';
    this.tags = [];
    this.eventCategory = 'AD';
    this.eventBus.subscribe(
      'LOADED',
      function () {
        this._clearSafetyTimer('LOADED');
        this._startSafetyTimer(8e3, 'LOADED');
      }.bind(this),
      'ima',
    );
    this.eventBus.subscribe(
      'STARTED',
      function () {
        this._clearSafetyTimer('STARTED');
      }.bind(this),
      'ima',
    );
  }

  async start() {
    var self = this;
    await this.adSystemInitialize(async () => {
      let parser = new URLParse(location.href, true);
      let po_referer = parser.query['po_referer'];

      let pageUrl = po_referer
        ? `https://h5.game8.io/${this.gameData.gameId}/?po_referer=${po_referer}`
        : 'ga8.io';

      let adsenseOptions = extendDefaults(this.options.adsense || {}, {
        // #game8
        adsense_client: 'ca-pub-8878309264050874',
        adsense_page_url: pageUrl,

        // #gamedistribution
        // adsense_client: "ca-pub-2316275586951220",
        // adsense_channel: "4089988593"
      });

      await self._init_afg_script(adsenseOptions);
    });
    self.afgInitSuccess = true;

    await this.adSystemInitialize(async () => {
      await self._init_hl_script();
      await self._init_ima_script();
      await self._createPlayer();
      await self._setUpIMA();
    });
    self.imaInitSuccess = true;
  }
  async adSystemInitialize(callback) {
    var result = {
      success: false,
    };
    try {
      await callback();
      result.success = true;
    } catch (error) {
      console.error('adSystemInitialize error', error);
      result.error = error;
    }
    return result;
  }
  nextAdPosition = function (e) {
    console.log('needImplement nextAdPosition', e);
  };
  getAdPosition = function (e) {
    console.log('needImplement getAdPosition', e);
  };
  getCurrentAdPosition = function (e) {
    if (e === AdType.Interstitial) {
      if (1 === this.adPrerollCount && 0 === this.adMidrollCount) return 'preroll';
      else return 'midroll';
    } else {
      if (e === AdType.Rewarded) return 'rewarded';
    }
  };
  _requestPromo = function (e, t) {
    console.log('needImplement _requestPromo', e, t);
  };
  _requestAd = function (v, b) {
    console.log('needImplement _requestAd', v, b);
  };
  _getExternalVast = function (e) {
    console.log('needImplement _getExternalVast', e);
  };

  /**
   * cancel
   * Makes it possible to stop an advertisement while its
   * loading or playing. This will clear out the adsManager, stop any
   * ad playing and allowing new ads to be called.
   * @public
   */
  cancel() {
    if (this.requestRunning === false) return;

    this.requestRunning = false;

    this._resetAdsLoader();

    // Hide the advertisement.
    this._hide('cancel');

    // Send event to tell that the whole advertisement thing is finished.
    let eventName = 'AD_SDK_CANCELED';
    let eventMessage = 'Advertisement has been canceled.';
    this.eventBus.broadcast(eventName, {
      name: eventName,
      message: eventMessage,
      status: 'warning',
      analytics: {
        category: this.eventCategory,
        action: eventName,
        label: this.gameData.gameId,
      },
    });
  }

  _checkAutoPlay = function (e) {
    console.log('needImplement _checkAutoPlay', e);
  };
  _initDisplayContainerWithAutoPlay = function (e) {
    console.log('needImplement _initDisplayContainerWithAutoPlay', e);
  };
  async startAd(t) {
    var r = t.adType;
    var o = t.params || {};
    o.adType = t.adType;
    this.adType_ = r;
    this.isAudioAd = false;
    this.adContext = o;
    if (this.gameData.adspn != null && this.gameData.adspn.enabled) {
      if (!this.adFlowProcessSpinner) {
        this.adFlowProcessSpinner = new AdFlowProcessSpinner();
        this.adFlowProcessSpinner.add();
      }
      this.adFlowProcessSpinner.show(true);
    }
    if (o.adapter === 'promo') return this._startPromo(o, r);
    if (o.adapter === 'adsense') {
      if (r === AdType.Interstitial) {
        if (o.position === 'preroll') return this._startAdsensePlacementPreroll(t);
        if (o.position === 'start') return this._startAdsensePlacementStart(t);
        if (o.position === 'next') return this._startAdsensePlacementNext(t);
        return this._startAdsensePlacementPreroll(t);
      }
      if (r === AdType.Rewarded) return this._startAdsensePlacementRewardedAd(t);
      throw new Error('Unsupported ad type');
    }
    if (
      ['ima', 'spil', 'audio'].some(function (e) {
        return e === o.adapter;
      })
    ) {
      if (r === AdType.Interstitial) return this._startInterstitialAd(o);
      if (r === AdType.Rewarded) return this._startRewardedAd(o);
    }
  }
  _onError = function (e) {
    this.cancel(e);
    this._clearSafetyTimer('ERROR');
  };
  _hide = function (e) {
    if (this.video_ad_player) this.video_ad_player.src = '';
    if (this.activeAdContainer) this.activeAdContainer.style.visibility = 'hidden';
  };
  _show = function (e) {
    // needImplement
  };
  _setUpIMA = function () {
    // this.adDisplayContainer = new google.ima.AdDisplayContainer(this.adContainerInner,this.video_ad_player),
    // this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer),
    // this.adsLoader.getSettings().setDisableCustomPlaybackForIOS10Plus(!0),
    // this.adsLoader.getSettings().setLocale(this.options.locale),
    // this.adsLoader.getSettings().setVpaidMode(this._getVPAIDMode()),
    // this.adsLoader.getSettings().setAutoPlayAdBreaks(!0);
    // var e = this.adsLoader.getSettings().getNumRedirects();
    // this.adsLoader.getSettings().setNumRedirects(2 * e),
    // this.adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this._onAdsManagerLoaded, !1, this),
    // this.adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this._onAdError, !1, this)
  };

  _resetAdsLoader() {
    if (this.adsManager) {
      this.adsManager.destroy();
      this.adsManager = null;
    }

    if (this.adsLoader) {
      this.adsLoader.contentComplete();
    }
  }

  async _init_afg_script(options) {
    options = options || {};
    var attrs = {};
    attrs['crossorigin'] = 'anonymous';
    attrs['data-page-url'] = options.adsense_page_url || 'game8.io';
    attrs['data-ad-client'] = options.adsense_client || 'ca-pub-8878309264050874';
    attrs['data-ad-frequency-hint'] = '30s';
    attrs['allow'] = 'autoplay';
    if (options.adsense_channel) attrs['data-ad-channel'] = options.adsense_channel;
    if (options.adsense_host) attrs['data-ad-host'] = options.adsense_host;
    if (options.adsense_adbreak_test) attrs['data-adbreak-test'] = 'on';
    await getScript(
      'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
      'g8plugin_afg',
      {
        attrs: attrs,
        error_prefix: 'Blocked:',
        exists: function () {
          return !!window.adsbygoogle;
        },
      },
    ).then(function () {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({
        sound: 'on',
        preloadAdBreaks: 'on',
      });
    });
  }
  _init_hl_script = function () {};
  _init_ima_script = function () {};
  _createPlayer = function () {};

  _broadcast = function (t, e) {
    e = e || {};
    e.skipForward = false;
    e.adPosition = this.getCurrentAdPosition(this.adContext.adType);
    this.eventBus.broadcast(t, e);
  };
  resetForNext = function () {
    this.requestRunning = false;
    // this._hide("resetForNext");
  };

  /**
   * preloadAd
   * Destroy the adsManager so we can grab new ads after this.
   * If we don't then we're not allowed to call new ads based
   * on google policies, as they interpret this as an accidental
   * video requests. https://developers.google.com/interactive-
   * media-ads/docs/sdks/android/faq#8
   * @param {String} adType
   * @return {Promise<any>}
   * @public
   */
  async preloadAd(adType) {
    if (adType === AdType.Interstitial) {
      // return this._preloadInterstitialAd();
      return 'gdsdk://preloaded';
    } else if (adType === AdType.Rewarded) {
      // return this._preloadRewardedAd();
      return 'gdsdk://preloaded';
    } else throw new Error('Unsupported ad type');
  }

  async _startAdsensePlacementPreroll(t) {
    if (this.requestRunning) {
      this._broadcast('AD_IS_ALREADY_RUNNING', {
        status: 'warning',
      });
      return;
    }
    this.requestRunning = true;
    var adBreakDone = function (e) {
      this.resetForNext();
      var t = 'preroll';
      this.adCounter[t] = this.adCounter[t] || 0;
      this.adCounter[t]++;
      if (e.breakStatus === 'viewed') {
        this._broadcast('CONTENT_PAUSE_REQUESTED', {
          message: '',
          status: 'success',
        });
        this._broadcast('IMPRESSION', {
          message: '',
          status: 'success',
        });
        this._broadcast('COMPLETE', {
          message: '',
          status: 'success',
        });
        this._broadcast('AD_SUCCESS', {
          message: 'Ad succeeded.',
          status: 'success',
        });
        this._broadcast('CONTENT_RESUME_REQUESTED', {
          message: '',
          status: 'success',
        });
      } else {
        this._broadcast('AD_ERROR', {
          message: e.breakStatus,
          status: 'error',
        });
      }
    }.bind(this);
    await window.adsbygoogle.push({
      type: 'preroll',
      adBreakDone: adBreakDone,
    });
  }
  _startAdsensePlacementStart = function (t) {};
  _startAdsensePlacementNext = function (t) {};
  _startAdsensePlacementRewardedAd = async function (t) {
    if (this.requestRunning) {
      this._broadcast('AD_IS_ALREADY_RUNNING', {
        status: 'warning',
      });
      return;
    }
    this.requestRunning = true;

    var adsConnected = false;
    var beforeAd = function () {
      adsConnected = true;
      this._broadcast('CONTENT_PAUSE_REQUESTED', {
        message: '',
        status: 'success',
      });
      this._broadcast('IMPRESSION', {
        message: '',
        status: 'success',
      });
    }.bind(this);
    var afterAd = function () {
      adsConnected = true;
      this._broadcast('CONTENT_RESUME_REQUESTED', {
        message: '',
        status: 'success',
      });
    }.bind(this);
    var adDismissed = function () {
      adsConnected = true;
    }.bind(this);
    var adViewed = function () {
      adsConnected = true;
      this._broadcast('COMPLETE', {
        message: '',
        status: 'success',
      });
      this._broadcast('SDK_REWARDED_WATCH_COMPLETE', {
        message: '',
        status: 'success',
      });
    }.bind(this);
    var beforeReward = function (callback) {
      adsConnected = true;
      callback();
    }.bind(this);
    var adBreakDone = function (e) {
      adsConnected = true;
      this.resetForNext();
      var t = 'rewarded';
      this.adCounter[t] = this.adCounter[t] || 0;
      this.adCounter[t]++;
      if ('viewed' === e.breakStatus) {
        this._broadcast('AD_SUCCESS', {
          message: 'Ad succeeded.',
          status: 'success',
        });
      } else {
        this._broadcast('AD_ERROR', {
          message: e.breakStatus,
          status: 'error',
          skipForward: true,
        });
      }
    }.bind(this);
    var showAd = function (e) {
      window.adsbygoogle.push(e);
    };
    setTimeout(
      function () {
        if (!adsConnected) {
          console.log('gd-adflow adsense.reward timeout happened!');
          this.requestRunning = !1;
          this._broadcast('AD_ERROR', {
            message: 'timeout',
            status: 'error',
            skipForward: true,
          });
        }
      }.bind(this),
      1000,
    );
    showAd({
      type: 'reward',
      name: 'reward-in-game',
      beforeAd: beforeAd,
      afterAd: afterAd,
      adDismissed: adDismissed,
      adViewed: adViewed,
      beforeReward: beforeReward,
      adBreakDone: adBreakDone,
    });
  };
}

export default AdInstance;
